var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M15.9993 29.3327C23.3631 29.3327 29.3327 23.3631 29.3327 15.9993C29.3327 8.63555 23.3631 2.66602 15.9993 2.66602C8.63555 2.66602 2.66602 8.63555 2.66602 15.9993C2.66602 23.3631 8.63555 29.3327 15.9993 29.3327Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 14.9993H16.9993V10.666C16.9993 10.1193 16.546 9.66602 15.9993 9.66602C15.4527 9.66602 14.9993 10.1193 14.9993 10.666V14.9993H10.666C10.1193 14.9993 9.66602 15.4527 9.66602 15.9993C9.66602 16.546 10.1193 16.9993 10.666 16.9993H14.9993V21.3327C14.9993 21.8793 15.4527 22.3327 15.9993 22.3327C16.546 22.3327 16.9993 21.8793 16.9993 21.3327V16.9993H21.3327C21.8793 16.9993 22.3327 16.546 22.3327 15.9993C22.3327 15.4527 21.8793 14.9993 21.3327 14.9993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledAdd);
export default __webpack_public_path__ + "static/media/disabledAdd.a2ac3ac3958a28239498073fec89244c.svg";
export { ForwardRef as ReactComponent };